<script setup lang="ts">
import { RouterView } from "vue-router";
import { onMounted, defineAsyncComponent } from "vue";
import { useAppStore } from "core-fe-lib/components-shadcn/stores/app-store";
import {
  ScrollArea,
  ScrollBar,
} from "core-fe-lib/components-shadcn/ui/scroll-area";
import { Toaster } from "core-fe-lib/components-shadcn/ui/toast";
import { TooltipProvider } from "core-fe-lib/components-shadcn/ui/tooltip";

// Lazy-load dialogs — not needed for first paint
const GlobalDialog = defineAsyncComponent(
  () => import("core-fe-lib/components-shadcn/primitives/GlobalDialog.vue")
);
const Aal2VerificationDialog = defineAsyncComponent(
  () => import("core-fe-lib/components-shadcn/auth/Aal2VerificationDialog.vue")
);
// Contextual upgrade dialog (ADR 024): opened on a 402 PLAN_LIMIT_REACHED or
// from a near/over-cap usage meter.
const PlanLimitDialog = defineAsyncComponent(
  () => import("credit-fe-lib/components/PlanLimitDialog.vue")
);

onMounted(() => {
  // Initialize theme
  useAppStore().initTheme();
});
</script>

<template>
  <TooltipProvider>
    <ScrollArea class="h-screen">
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
      <ScrollBar class="z-50" />
    </ScrollArea>
    <Toaster />
    <GlobalDialog />
    <Aal2VerificationDialog webauthn-mode="popup" />
    <PlanLimitDialog />
  </TooltipProvider>
</template>
